import { render, staticRenderFns } from "./ConfigProdutividadeParams.vue?vue&type=template&id=365e9a8a&scoped=true&lang=pug&"
import script from "./ConfigProdutividadeParams.vue?vue&type=script&lang=js&"
export * from "./ConfigProdutividadeParams.vue?vue&type=script&lang=js&"
import style0 from "./ConfigProdutividadeParams.vue?vue&type=style&index=0&id=365e9a8a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365e9a8a",
  null
  
)

export default component.exports